import { useDispatch } from "react-redux";
import { Button } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../redux/store/store";
import TickIcon from "../../../svg/tick-underline";

interface ReviewButtonProps {
  orderId: string;
  hasReviewDocuments: boolean;
}

const ReviewButton = (props: ReviewButtonProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleReviewClick = () => {
    dispatch(
      setOpenedModalId({
        id: ModalId.REVIEW_MODAL,
      }),
    );
  };

  if (props.hasReviewDocuments) {
    return (
      <div className="flex items-center gap-2">
        <span className="font text-small font-bold text-primaryGray-2">
          Review Submitted
        </span>
        <TickIcon />
      </div>
    );
  }

  return (
    <Button
      buttonType="primary"
      size="medium"
      onClick={handleReviewClick}
      disabled={false}
    >
      Review
    </Button>
  );
};

export default ReviewButton;
